<template>
  <div id="myElement" style="position: absolute; width: 100%; height: 100%; top: 0; background: #f0f3f7">
    <div class="digSHowBox" v-if="carmerShow">
      <div class="cameraBox">
        <div style="" class="box1">人脸认证核验</div>
        <div class="box2">为保证考试严肃，需本人进行人脸认证核验后才能继续考试学习</div>
        <div style="" class="bkBox box3">
          <div class="bk">
            <img class="box4" src="../../assets/examImgs/bk.png" alt="" />
          </div>
          <img v-if="showImg" :src="imgUrl" alt="" class="box5" />
          <video v-if="!showImg" class="box23" id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay></video>
          <canvas id="canvasCamera" style="display: none" :width="videoWidth" :height="videoHeight"></canvas>
        </div>

        <div @click="setImage()" class="camerBtn">立即认证核验</div>
      </div>
    </div>

    <div class="header">
      <div>{{ examInfo.quizName }}</div>

      <!-- <div class="time">{{ timeimit }}</div> -->

      <!-- <div style="display: flex">
        <div>{{ examInfo.userName }}</div>
        <div style="" class="box6">
          <img style="" class="box7" v-if="examInfo.userPhoto != '' && examInfo.userPhoto != null" :src="examInfo.userPhoto" alt="" />
          <img
            src="../../assets/images/noUser.png"
            style="width: 38px; height: 38px; border-radius: 50%; margin-left: 20px"
            alt=""
            v-else
          />
        </div>
      </div> -->
    </div>

    <div class="examBanner">
      <div class="examLeft">
        <div class="scollBox box8" style="">
          <div style="" class="box9">
            <div style="" class="box10"></div>

            <div style="" class="box11">答题卡</div>
          </div>

          <div class="box12" v-for="msg in examData" :key="msg.type">
            <!-- 单选题 -->
            <div v-if="msg.qType == '0501'">
              <div class="box13">单选题（共{{ danxuanList.length }}题，合计{{ danxuanList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div
                  v-for="(item, index) in danxuanList"
                  :key="item.id"
                  :class="item.z ? 'color7 box14' : swiperIndex == index && !item.z ? 'color5 box14' : 'color6 box14'"
                  @click="toSn(index)"
                >
                  {{ index + 1 }}
                </div>
              </div>
            </div>
            <!-- 单选题end -->
            <!-- 多选题 -->
            <div class="box15" v-if="msg.qType == '0502'">
              <div class="box13">多选题（共{{ duoxuanList.length }}题，合计{{ duoxuanList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div
                  v-for="(item, index) in duoxuanList"
                  :key="item.id"
                  :class="item.z ? 'color7 box14' : swiperIndex == danxuanList.length + index && !item.z ? 'color5 box14' : 'color6 box14'"
                  @click="toSn(danxuanList.length + index)"
                >
                  {{ danxuanList.length + 1 + index }}
                </div>
              </div>
            </div>
            <!-- 多选题end -->
            <!-- 判断题 -->
            <div class="box15" v-if="msg.qType == '0503'">
              <div class="box13">判断题（共{{ panduanList.length }}题，合计{{ panduanList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div
                  v-for="(item, index) in panduanList"
                  :key="item.id"
                  :class="
                    item.z
                      ? 'color7 box14'
                      : swiperIndex == danxuanList.length + duoxuanList.length + index && !item.z
                      ? 'color5 box14'
                      : 'color6 box14'
                  "
                  @click="toSn(danxuanList.length + duoxuanList.length + index)"
                >
                  {{ danxuanList.length + duoxuanList.length + 1 + index }}
                </div>
              </div>
            </div>
            <!-- 判断题end -->
            <!-- 简答题 -->
            <div class="box15" v-if="msg.qType == '0504'">
              <div class="box13">简答题（共{{ jiandaList.length }}题，合计{{ jiandaList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div
                  v-for="(item, index) in jiandaList"
                  :key="item.id"
                  :class="
                    item.z
                      ? 'color7 box14'
                      : swiperIndex == danxuanList.length + duoxuanList.length + +panduanList.length + index && !item.z
                      ? 'color5 box14'
                      : 'color6 box14'
                  "
                  @click="toSn(danxuanList.length + duoxuanList.length + panduanList.length + index)"
                >
                  {{ danxuanList.length + duoxuanList.length + panduanList.length + 1 + index }}
                </div>
              </div>
            </div>
            <!-- 简答题end -->

            <!-- 阅读理解题 -->
            <div class="box15" v-if="msg.qType == '0506'">
              <div class="box13">阅读理解题（共{{ shicaoList.length }}题，合计{{ shicaoList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div
                  v-for="(item, index) in shicaoList"
                  :key="item.id"
                  :class="
                    item.z
                      ? 'color7 box14'
                      : swiperIndex == danxuanList.length + duoxuanList.length + +panduanList.length + jiandaList.length + index && !item.z
                      ? 'color5 box14'
                      : 'color6 box14'
                  "
                  @click="toSn(danxuanList.length + duoxuanList.length + panduanList.length + jiandaList.length + index)"
                >
                  {{ danxuanList.length + duoxuanList.length + panduanList.length + jiandaList.length + 1 + index }}
                </div>
              </div>
            </div>
            <!-- 阅读理解题end -->
          </div>
        </div>
        <div class="optionTips">
          <div class="yuan box24"></div>
          <div class="box16">未答</div>
          <div class="yuan box25" style="background: #5ad068"></div>
          <div class="box16">进行</div>
          <div class="yuan box25" style="background: #4275f5"></div>
          <div class="box16">已答</div>
        </div>
      </div>
      <!-- 题目选项模块 -->
      <div class="examCenter">
        <swiper id="swiper" ref="mySwiper" class="swiper swiper-no-swiping">
          <swiper-slide v-for="(item, index) in danxuanList" :key="item.id">
            <!-- 单选题 -->
            <div style="display: flex">
              <div class="timu">
                <div class="titleTips">单选题</div>
                <div>{{ index + 1 }}: {{ item.content }}</div>
                <div class="box17" v-for="(img, idx) in item.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box18">
                  <div
                    @click="onSelet(index, idx)"
                    v-for="(data, idx) in item.optionList"
                    :key="data.id"
                    :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                  >
                    <div>
                      <img v-if="!data.selected" class="box26" src="../../assets/examImgs/nos@2x.png" alt="" />
                      <img v-else class="box26" src="../../assets/examImgs/se@2x.png" alt="" />
                    </div>
                    <div class="box25">
                      <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                      >&emsp;{{ data.opContent }}
                    </div>

                    <div class="box27" v-for="(img, idx) in data.imgs" :key="idx">
                      <img style="width: 100%" :src="img" alt="" />
                    </div>
                  </div>
                </div>

                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi(index)">上一题</div>
                  <div @click="dowTi(item, index)" class="btn box21">下一题</div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide v-for="(item, index) in duoxuanList" :key="item.id">
            <!-- 多选题 -->
            <div style="display: flex">
              <div class="timu">
                <div class="titleTips">多选题</div>
                <div>{{ danxuanList.length + 1 + index }}: {{ item.content }}</div>
                <div class="box17" v-for="(img, idx) in item.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box18">
                  <div v-for="(data, idx) in item.optionList" :key="data.id">
                    <div @click="onDuoSelet(index, idx)" :key="num" :class="data.selected ? 'seletXuan xuan' : 'xuan'">
                      <div>
                        <img v-if="!data.selected" class="box26" src="../../assets/examImgs/nos@2x.png" alt="" />
                        <img v-else class="box26" src="../../assets/examImgs/se@2x.png" alt="" />
                      </div>
                      <div class="box25">
                        <span style="font-family: Bold">{{
                          idx == 0
                            ? 'A'
                            : idx == 1
                            ? 'B'
                            : idx == 2
                            ? 'C'
                            : idx == 3
                            ? 'D'
                            : idx == 4
                            ? 'E'
                            : idx == 5
                            ? 'F'
                            : idx == 6
                            ? 'G'
                            : idx == 7
                            ? 'H'
                            : 'I'
                        }}</span
                        >&emsp;{{ data.opContent }}
                      </div>
                      <div class="box17" v-for="(img, idx) in data.imgs" :key="idx">
                        <img style="width: 100%" :src="img" alt="" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi(index)">上一题</div>
                  <div @click="dowTi(item, index)" class="btn box21">下一题</div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide v-for="(item, index) in panduanList" :key="item.id">
            <!-- 判断 -->
            <div style="display: flex">
              <div class="timu">
                <div class="titleTips">判断题</div>
                <div>{{ danxuanList.length + duoxuanList.length + 1 + index }}: {{ item.content }}</div>
                <div class="box17" v-for="(img, idx) in item.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box18" :key="num">
                  <div
                    @click="onPanSelet(index, idx)"
                    v-for="(data, idx) in item.optionList"
                    :key="idx"
                    :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                  >
                    <div>
                      <img v-if="!data.selected" class="box26" src="../../assets/examImgs/nos@2x.png" alt="" />
                      <img v-else class="box26" src="../../assets/examImgs/se@2x.png" alt="" />
                    </div>
                    <div class="box25">
                      <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                      >&emsp;{{ data.opContent }}
                    </div>
                  </div>
                </div>

                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi(index)">上一题</div>
                  <div @click="dowTi(item, index)" class="btn box21">下一题</div>
                </div>
              </div>
            </div>
          </swiper-slide>

          <swiper-slide v-for="(item, index) in jiandaList" :key="item.id">
            <!-- 简答 -->
            <div style="display: flex">
              <div class="timu">
                <div class="titleTips">简答题</div>
                <div>{{ danxuanList.length + duoxuanList.length + panduanList.length + 1 + index }}: {{ item.content }}</div>
                <div class="box17" v-for="(img, idx) in item.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>
              </div>
              <div class="xuanx box19">
                <div class="scollBox box18" :key="num">
                  <el-input
                    class="box20"
                    @change="oninpus"
                    type="textarea"
                    :autosize="{ minRows: 20, maxRows: 30 }"
                    placeholder="请考生作答"
                    v-model="item.z"
                  >
                  </el-input>
                </div>
                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi(index)">上一题</div>
                  <div @click="dowTi(item, index)" class="btn box21">下一题</div>
                </div>
              </div>
            </div>
          </swiper-slide>

          <swiper-slide v-for="(item, index) in shicaoList" :key="item.id">
            <!-- 阅读理解 -->
            <div style="display: flex">
              <div class="timu">
                <div class="titleTips">阅读理解题</div>
                <div>
                  {{ danxuanList.length + duoxuanList.length + jiandaList.length + panduanList.length + 1 + index }}: {{ item.content }}
                </div>
                <div class="box17" v-for="(img, idx) in item.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>

                <!-- 子单选题目 -->
                <div v-if="item.subList_1.length !== 0">
                  <div>单选题</div>
                  <div class="timu box22" v-for="(msg, idx) in item.subList_1" :key="msg.pqId">
                    <div class="box16">&emsp;({{ idx + 1 }})&emsp;{{ msg.content }}</div>
                    <div class="box17" v-for="(img, idx) in msg.imgs" :key="idx">
                      <img style="width: 100%" :src="img" alt="" />
                    </div>
                  </div>
                </div>
                <!-- 子单选题目end -->

                <!-- 子多选题目 -->
                <div v-if="item.subList_2.length !== 0">
                  <div>多选题</div>
                  <div class="timu box22" v-for="(msg, idx) in item.subList_2" :key="msg.pqId">
                    <div class="box16">&emsp;({{ idx + 1 }})&emsp;{{ msg.content }}</div>
                    <div class="box17" v-for="(img, idx) in msg.imgs" :key="idx">
                      <img style="width: 100%" :src="img" alt="" />
                    </div>
                  </div>
                </div>
                <!-- 子多选题目end -->
                <!-- 子判断题目 -->
                <div v-if="item.subList_3.length !== 0">
                  <div>判断题</div>
                  <div class="timu box22" v-for="(msg, idx) in item.subList_3" :key="msg.pqId">
                    <div class="box16">&emsp;({{ idx + 1 }})&emsp;{{ msg.content }}</div>
                    <div class="box17" v-for="(img, idx) in msg.imgs" :key="idx">
                      <img style="width: 100%" :src="img" alt="" />
                    </div>
                  </div>
                </div>
                <!-- 子判断题目end -->

                <!-- 子简答题 -->
                <div v-if="item.subList_4.length !== 0">
                  <div>简答题</div>
                  <div class="timu box22" v-for="(msg, idx) in item.subList_4" :key="msg.pqId">
                    <div class="box16">&emsp;({{ idx + 1 }})&emsp;{{ msg.content }}</div>
                    <div class="box17" v-for="(img, idx) in msg.imgs" :key="idx">
                      <img style="width: 100%" :src="img" alt="" />
                    </div>
                  </div>
                </div>
                <!-- 子简答题end -->
              </div>
              <div class="xuanx box19">
                <div class="scollBox box28">
                  <!-- 子单选题选项 -->
                  <div v-if="item.subList_1.length">
                    <div class="box29">单选题选项</div>
                    <div v-for="(dzt, cindex) in item.subList_1" :key="dzt.pqId">
                      <div class="box29">({{ cindex + 1 }})</div>
                      <div
                        @click="onzSelet(index, cindex, idx)"
                        v-for="(data, idx) in dzt.optionList"
                        :key="data.id"
                        :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                      >
                        <div>
                          <img v-if="!data.selected" class="box26" src="../../assets/examImgs/nos@2x.png" alt="" />
                          <img v-else class="box26" src="../../assets/examImgs/se@2x.png" alt="" />
                        </div>
                        <div class="box25">
                          <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                          >&emsp;{{ data.opContent }}
                        </div>

                        <div class="box27" v-for="(img, idx) in data.imgs" :key="idx">
                          <img style="width: 100%" :src="img" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 子单选题选项end -->

                  <!-- 子多选题选项 -->
                  <div v-if="item.subList_2.length">
                    <div class="box29">多题选项</div>

                    <div v-for="(dzt, cindex) in item.subList_2" :key="dzt.pqId">
                      <div class="box29">({{ cindex + 1 }})</div>
                      <div
                        @click="onzDuoSelet(index, cindex, idx)"
                        v-for="(data, idx) in dzt.optionList"
                        :key="data.id"
                        :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                      >
                        <div>
                          <img v-if="!data.selected" class="box26" src="../../assets/examImgs/nos@2x.png" alt="" />
                          <img v-else class="box26" src="../../assets/examImgs/se@2x.png" alt="" />
                        </div>
                        <div class="box25">
                          <span style="font-family: Bold">{{
                            idx == 0
                              ? 'A'
                              : idx == 1
                              ? 'B'
                              : idx == 2
                              ? 'C'
                              : idx == 3
                              ? 'D'
                              : idx == 4
                              ? 'E'
                              : idx == 5
                              ? 'F'
                              : idx == 6
                              ? 'G'
                              : idx == 7
                              ? 'H'
                              : 'I'
                          }}</span
                          >&emsp;{{ data.opContent }}
                        </div>

                        <div class="box27" v-for="(img, idx) in data.imgs" :key="idx">
                          <img style="width: 100%" :src="img" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 子多选题选项end -->

                  <!-- 子判断题选项 -->
                  <div v-if="item.subList_3.length">
                    <div class="box29">判断题选项</div>

                    <div v-for="(dzt, cindex) in item.subList_3" :key="dzt.pqId">
                      <div class="box29">({{ cindex + 1 }})</div>
                      <div
                        @click="onzPanSelet(index, cindex, idx)"
                        v-for="(data, idx) in dzt.optionList"
                        :key="data.id"
                        :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                      >
                        <div>
                          <img v-if="!data.selected" class="box26" src="../../assets/examImgs/nos@2x.png" alt="" />
                          <img v-else class="box26" src="../../assets/examImgs/se@2x.png" alt="" />
                        </div>
                        <div class="box25">
                          <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                          >&emsp;{{ data.opContent }}
                        </div>
                        <div class="box27" v-for="(img, idx) in data.imgs" :key="idx">
                          <img style="width: 100%" :src="img" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 子判断题选项end -->

                  <!-- 子简答题选项 -->
                  <div v-if="item.subList_4.length">
                    <div class="box29">简答题选项</div>

                    <div v-for="(dzt, cindex) in item.subList_4" :key="dzt.pqId">
                      <div class="box29">({{ cindex + 1 }})</div>
                      <el-input
                        type="textarea"
                        @input="oninpus($event)"
                        :autosize="{ minRows: 20, maxRows: 30 }"
                        placeholder="请考生作答"
                        v-model="dzt.z"
                      >
                      </el-input>
                    </div>
                  </div>
                  <!-- 子简答题选项end -->
                </div>
                <div class="switchBox">
                  <div class="btn" style="color: #4275f5" @click="upTi(index)">上一题</div>
                  <div @click="dowTi(item, index)" class="btn box21">下一题</div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <!-- 题目选项模块end -->
      <div class="examRight">
        <div class="box30">
          <div class="box31">
            <div class="box32"></div>

            <div class="box33">考试须知</div>
          </div>

          <div class="box34">
            <div class="fs scollBox">
              <div>
                {{ examInfo.quizDescription }}
              </div>
            </div>

            <!-- <div v-if="isSign !== '01'"
                 class="qd">
              <div style="display: flex">
                <div>
                  <img class="box35"
                       src="../../assets/examImgs/qiandao@2x.png"
                       alt="" />
                </div>

                <div class="box39">已签到</div>
              </div>
            </div>

            <div v-else
                 class="qd"
                 style="background: #fe5f5e;"
                 @click="onQd">
              <div style="display: flex">
                <div>
                  <img class="box35"
                       src="../../assets/examImgs/qiandao@2x.png"
                       alt="" />
                </div>

                <div class="box39">签到</div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="box36">
          <div class="box31">
            <div class="box32"></div>

            <div class="box33">提交考卷</div>
          </div>

          <div class="box37">
            <!-- <div style="color: #8793a4; text-align: center">当前进度</div> -->
            <!--
            <div style="
                color: #fff;
                margin-top: 11px;
                width: 200px;
                height: 20px;
                background: rgba(80,124,247,.15);
                border-radius: 10px;
                text-align: center;
                position: relative;
                z-index: 2;
              ">
              <div class="percentage"
                   :style="{width:Math.round((percentageNum/totleNum)*100)+'%'}">

              </div>
              <div style="position: relative;
                z-index: 2;"> {{Math.round((percentageNum/totleNum) *100)}}%</div>
            </div> -->

            <div class="submit" @click="submitExams">
              <div style="display: flex">
                <div>
                  <img class="box38" src="../../assets/examImgs/submit@2x.png" alt="" />
                </div>
                <div class="box16">提交考卷</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="dialogVisible"
         style=""
         class="box47">
      <div class="dia">
        <div class="box49"
             style="">提示</div>

        <div style=""
             class="box50">
          <div style="font-family: Medium">&emsp;&emsp;检测到您退出全屏：</div>
          <div>
            &emsp;&emsp;禁止退出全屏，否则会影响您考试成绩！请点击确认后继续考试！
          </div>

        </div>
        <div @click="doExam"
             class="qBtn">确认</div>
      </div>
    </div> -->
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// Import Swiper Vue.js components
import { Loading } from 'element-ui';
import { toMockJoinExam, handInNew, handIn } from '../../api/study';
// Import Swiper styles
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      examData: [], //题目数据
      swiperIndex: 0, //当前页面的题目索引
      num: 0, //key值重置
      danxuanList: [], //单选题的数组
      duoxuanList: [], //多选题
      panduanList: [], //判断题
      jiandaList: [], //简答题
      shicaoList: [], //阅读理解,阅读理解
      videoWidth: 170,
      videoHeight: 170,
      imgSrc: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      //相机截图工具
      face_back_canvas: null,
      //截图内容
      face_back_context: null,
      //照片的base64码值
      face_back_base64Photo: '',
      showImg: false, //截图的图片
      carmerShow: false, //人脸识别组件
      examInfo: {}, //试卷数据
      timeimit: 0, //倒计时
      time: '', //倒计时
      interval: null, //定时器
      isSign: '01', //签到状态
      percentageNum: 0, //已做
      totleNum: 0, //总数
      handInTimer: null, //定时器
      findTimer: null,
      webSocket: null,
      surl: '',
      setIntervalWesocketPush: null, //定时器
      dialogVisible: false,
      isFullScreen: false
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //输入框不能输入的bug
    oninpus(e) {
      this.$forceUpdate();
      console.log(e);
    },
    //处理考试进度百分比
    percentage() {
      this.totleNum =
        this.danxuanList.length + this.duoxuanList.length + +this.panduanList.length + this.jiandaList.length + this.shicaoList.length;
    },
    //五分钟提交一下试卷
    handIn() {
      let data = {
        uqId: this.examInfo.uqId,
        uqdId: this.examInfo.uqdId,
        type: '01'
      };
      this.danxuanList.forEach(v => {
        v.optionList.forEach(x => {
          if (x.selected) {
            data[v.pqId] = x.id;
          }
        });
      });
      this.duoxuanList.forEach(v => {
        let arr = [];
        v.optionList.forEach(x => {
          if (x.selected) {
            console.log(x);
            arr.push(x.id);
            console.log(arr);
            data[v.pqId] = arr.toString();
          }
        });
      });
      this.panduanList.forEach(v => {
        v.optionList.forEach(x => {
          if (x.selected) {
            data[v.pqId] = x.opContent == '对' ? '01' : '00';
          }
        });
      });

      this.jiandaList.forEach(v => {
        if (v.z && v.z !== '') {
          data[v.pqId] = v.z;
        }
      });

      this.shicaoList.forEach(c => {
        if (c.subList_1.length !== 0) {
          c.subList_1.forEach(v => {
            v.optionList.forEach(x => {
              if (x.selected) {
                data[v.pqId] = x.id;
              }
            });
          });
        }

        if (c.subList_2.length !== 0) {
          c.subList_2.forEach(v => {
            let arr = [];
            v.optionList.forEach(x => {
              if (x.selected) {
                console.log(x);
                arr.push(x.id);
                console.log(arr);
                data[v.pqId] = arr.toString();
              }
            });
          });
        }

        if (c.subList_3.length !== 0) {
          c.subList_3.forEach(v => {
            v.optionList.forEach(x => {
              if (x.selected) {
                data[v.pqId] = x.opContent == '对' ? '01' : '00';
              }
            });
          });
        }

        if (c.subList_4.length !== 0) {
          c.subList_4.forEach(v => {
            if (v.z && v.z !== '') {
              data[v.pqId] = v.z;
            }
          });
        }
      });
      handIn(data).then(res => {
        console.log(res);
      });
    },
    //提交试卷校验最小答题时间
    submitExams() {
      this.$confirm('确定要提交试卷吗?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.submitExam();
        })
        .catch(() => {});
    },
    //提交试卷
    submitExam(id) {
      let loadingInstance = Loading.service({
      lock: true,
      text: '提交试卷中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, .2)'
    });
      let data = {
        uqId: this.examInfo.uqId,
        uqdId: this.examInfo.uqdId,
        type: '01'
      };
      this.danxuanList.forEach(v => {
        v.optionList.forEach(x => {
          if (x.selected) {
            data[v.pqId] = x.id;
          }
        });
      });
      this.duoxuanList.forEach(v => {
        let arr = [];
        v.optionList.forEach(x => {
          if (x.selected) {
            console.log(x);
            arr.push(x.id);
            console.log(arr);
            data[v.pqId] = arr.toString();
          }
        });
      });
      this.panduanList.forEach(v => {
        v.optionList.forEach(x => {
          if (x.selected) {
            data[v.pqId] = x.opContent == '对' ? '01' : '00';
          }
        });
      });

      this.jiandaList.forEach(v => {
        if (v.z && v.z !== '') {
          data[v.pqId] = v.z;
        }
      });

      this.shicaoList.forEach(c => {
        if (c.subList_1.length !== 0) {
          c.subList_1.forEach(v => {
            v.optionList.forEach(x => {
              if (x.selected) {
                data[v.pqId] = x.id;
              }
            });
          });
        }

        if (c.subList_2.length !== 0) {
          c.subList_2.forEach(v => {
            let arr = [];
            v.optionList.forEach(x => {
              if (x.selected) {
                console.log(x);
                arr.push(x.id);
                console.log(arr);
                data[v.pqId] = arr.toString();
              }
            });
          });
        }

        if (c.subList_3.length !== 0) {
          c.subList_3.forEach(v => {
            v.optionList.forEach(x => {
              if (x.selected) {
                data[v.pqId] = x.opContent == '对' ? '01' : '00';
              }
            });
          });
        }

        if (c.subList_4.length !== 0) {
          c.subList_4.forEach(v => {
            if (v.z && v.z !== '') {
              data[v.pqId] = v.z;
            }
          });
        }
      });
      handInNew(data).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          loadingInstance.close();
          //提示成功
          this.$message({
            message: '提交试卷成功！',
            type: 'success'
          });
          this.$router.replace({
            path: '/studyMain',
            query: {
              tabIndex: 10
            }
          });
        } else {
          loadingInstance.close();
          //提示失败
          this.$message(res.data.msg);
        }
      });
    },
    //考试倒计时
    begin() {
      this.time = this.examInfo.timeimit * 60;
      this.handleCountDown();
    },
    handleCountDown() {
      this.interval = setInterval(() => {
        this.time--;
        let minutes = Math.floor(this.time / 60);
        let seconds = Math.floor(this.time % 60);
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        this.timeimit = minutes + '分' + seconds + '秒';
        if (this.time === 0) {
          clearInterval(this.interval);
          //到时间自动交卷
          this.submitExam();
        }
      }, 1000);
    },
    //单选题选择选项
    onSelet(index, idx) {
      this.danxuanList[index].z = true;

      this.danxuanList[index].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      this.num = this.num + 1;
    },

    //多选题选择选项
    onDuoSelet(index, idx) {
      if (this.duoxuanList[index].optionList[idx].selected) {
        this.duoxuanList[index].optionList[idx].selected = false;
        this.duoxuanList[index].z = false;
        this.percentageNum = this.percentageNum - 1;
        this.num = this.num + 1;
        return false;
      }
      this.duoxuanList[index].z = true;

      this.duoxuanList[index].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        }
      });
      this.num = this.num + 1;
    },
    //判断题选择选项
    onPanSelet(index, idx) {
      console.log(this.panduanList[index]);
      this.panduanList[index].z = true;

      this.panduanList[index].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      this.num = this.num + 1;
    },
    //阅读理解子单选题选项
    onzSelet(index, cindex, idx) {
      console.log(index, cindex, idx);
      this.shicaoList[index].z = true;

      this.shicaoList[index].subList_1[cindex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      this.num = this.num + 1;
    },
    //阅读理解子多选题选择选项
    onzDuoSelet(index, cindex, idx) {
      this.shicaoList[index].z = true;
      if (this.shicaoList[index].subList_2[cindex].optionList[idx].selected) {
        this.shicaoList[index].subList_2[cindex].optionList[idx].selected = false;
        this.shicaoList[index].z = false;
        this.percentageNum = this.percentageNum - 1;
        this.num = this.num + 1;
        return false;
      }
      this.shicaoList[index].z = true;

      this.shicaoList[index].subList_2[cindex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        }
      });
      this.num = this.num + 1;
    },
    //判断题选择选项
    onzPanSelet(index, cindex, idx) {
      this.shicaoList[index].z = true;

      this.shicaoList[index].subList_3[cindex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      this.num = this.num + 1;
    },
    //答题卡点击事件
    toSn(idx) {
      console.log(idx);
      // if (this.isSign == '01') {
      //   this.$message({
      //     message: '请先签到之后再答题！',
      //     type: 'warning'
      //   });
      //   return false;
      // }
      this.$refs.mySwiper.swiperInstance.slideTo(idx);
      this.swiperIndex = this.$refs.mySwiper.swiperInstance.activeIndex;
    },
    //上一题
    upTi(index) {
      this.$refs.mySwiper.swiperInstance.slidePrev();
      this.swiperIndex = this.$refs.mySwiper.swiperInstance.activeIndex;
      window.scrollTo(0, 0);
    },
    //下一题
    dowTi(item, index) {
      if (item.z) {
        this.percentageNum = this.percentageNum + 1;
      }
      // if (this.isSign == '01') {
      //   this.$message({
      //     message: '请先签到之后再答题！',
      //     type: 'warning'
      //   });
      //   return false;
      // }
      this.$refs.mySwiper.swiperInstance.slideNext();
      this.swiperIndex = this.$refs.mySwiper.swiperInstance.activeIndex;
      window.scrollTo(0, 0);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let loadingInstance = Loading.service({
      lock: true,
      text: '题目加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, .2)'
    });
    let _this = this;
    //题目接口数据
    toMockJoinExam({ uqId: this.$route.query.uqId }).then(res => {
      _this.examData = res.data.data.list;
      _this.examInfo = res.data.data;
      _this.isSign = res.data.data.isSign;
      _this.begin();
      _this.examData.forEach(item => {
        //处理数据
        if (item.qType == '0501') {
          _this.danxuanList = item.qList_0501;
          if (_this.danxuanList.length) {
            _this.danxuanList.forEach(v => {
              //分割图片和题目
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.z) {
                _this.percentageNum = _this.percentageNum + 1;
              }
              v.optionList.forEach(x => {
                let ass = x.opContent.split('*');
                x.opContent = ass[0];
                ass.splice(0, 1);
                ass.splice(ass.length - 1, 1);
                x.imgs = ass;
              });
            });
          }
        } else if (item.qType == '0502') {
          _this.duoxuanList = item.qList_0502;

          if (_this.duoxuanList.length) {
            _this.duoxuanList.forEach(v => {
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.z) {
                _this.percentageNum = _this.percentageNum + 1;
              }
              v.optionList.forEach(x => {
                let ass = x.opContent.split('*');
                x.opContent = ass[0];
                ass.splice(0, 1);
                ass.splice(ass.length - 1, 1);
                x.imgs = ass;
              });
            });
          }
        } else if (item.qType == '0503') {
          _this.panduanList = item.qList_0503;

          if (_this.panduanList.length) {
            _this.panduanList.forEach(v => {
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.z) {
                _this.percentageNum = _this.percentageNum + 1;
              }
              if (v.answer == 'true') {
                v.optionList = [
                  { opContent: '对', selected: true },
                  { opContent: '错', selected: false }
                ];
              } else if (!v.answer) {
                v.optionList = [
                  { opContent: '对', selected: false },
                  { opContent: '错', selected: false }
                ];
              } else {
                v.optionList = [
                  { opContent: '对', selected: false },
                  { opContent: '错', selected: true }
                ];
              }
            });
          }
        } else if (item.qType == '0504') {
          _this.jiandaList = item.qList_0504;

          if (_this.jiandaList.length) {
            _this.jiandaList.forEach(v => {
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.z) {
                _this.percentageNum = _this.percentageNum + 1;
              }
              if (v.userAnswer !== null) {
                if (v.userAnswer.answer !== '' && v.userAnswer.answer !== null) {
                  v.z = v.userAnswer.answer;
                }
              }
            });
          }
        } else {
          _this.shicaoList = item.qList_0506;
          if (_this.shicaoList.length) {
            _this.shicaoList.forEach(v => {
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.z) {
                _this.percentageNum = _this.percentageNum + 1;
              }
              //处理阅读理解题下的单选多选简答判断
              if (v.subList_1.length) {
                v.subList_1.forEach(cc => {
                  //分割图片和题目
                  let sArr = cc.content.split('*');
                  cc.content = sArr[0];
                  sArr.splice(0, 1);
                  sArr.splice(sArr.length - 1, 1);
                  cc.imgs = sArr;
                  cc.optionList.forEach(x => {
                    let ass = x.opContent.split('*');
                    x.opContent = ass[0];
                    ass.splice(0, 1);
                    ass.splice(ass.length - 1, 1);
                    x.imgs = ass;
                  });
                });
              }

              if (v.subList_2.length) {
                v.subList_2.forEach(cc => {
                  //分割图片和题目
                  let sArr = cc.content.split('*');
                  cc.content = sArr[0];
                  sArr.splice(0, 1);
                  sArr.splice(sArr.length - 1, 1);
                  cc.imgs = sArr;
                  cc.optionList.forEach(x => {
                    let ass = x.opContent.split('*');
                    x.opContent = ass[0];
                    ass.splice(0, 1);
                    ass.splice(ass.length - 1, 1);
                    x.imgs = ass;
                  });
                });
              }

              if (v.subList_3.length) {
                v.subList_3.forEach(cc => {
                  let arr = cc.content.split('*');
                  cc.content = arr[0];
                  arr.splice(0, 1);
                  arr.splice(arr.length - 1, 1);
                  cc.imgs = arr;
                  if (cc.userAnswer == null) {
                    cc.optionList = [
                      { opContent: '对', selected: false },
                      { opContent: '错', selected: false }
                    ];
                  } else if (cc.userAnswer.answer == '01') {
                    cc.optionList = [
                      { opContent: '对', selected: true },
                      { opContent: '错', selected: false }
                    ];
                  } else if (cc.userAnswer.answer == null) {
                    cc.optionList = [
                      { opContent: '对', selected: false },
                      { opContent: '错', selected: false }
                    ];
                  } else {
                    cc.optionList = [
                      { opContent: '对', selected: false },
                      { opContent: '错', selected: true }
                    ];
                  }
                });
              }

              if (v.subList_4.length) {
                v.subList_4.forEach(cc => {
                  let arr = cc.content.split('*');
                  cc.content = arr[0];
                  arr.splice(0, 1);
                  arr.splice(arr.length - 1, 1);
                  cc.imgs = arr;
                  if (cc.userAnswer !== null) {
                    if (cc.userAnswer.answer !== '' && cc.userAnswer.answer !== null) {
                      cc.z = cc.userAnswer.answer;
                    }
                  }
                });
              }
            });
          }
        }
      });
      loadingInstance.close();
      _this.percentage();
    });
    //开启五分钟记录试卷
    // _this.handInTimer = setInterval(() => {
    //   _this.handIn();
    // }, 5 * 60 * 1000);
  },
  destroyed() {},
  beforeDestroy() {
    //销毁定时器
    clearTimeout(this.setIntervalWesocketPush);
    clearInterval(this.handInTimer);
    clearInterval(this.findTimer);
    clearInterval(this.interval);
    this.handInTimer = null;
    this.findTimer = null;
    this.interval = null;
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */

.dia {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  font-size: 16px;
  font-family: Regular;
}
.qBtn {
  width: 180px;
  height: 50px;
  background: #4275f5;
  opacity: 1;
  border-radius: 25px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  line-height: 50px;
  margin: 23px auto auto auto;
}
.box1 {
  font-family: Bold;
  font-size: 18px;
  text-align: center;
}
.box2 {
  margin-top: 8px;
}
.box3 {
  margin-top: 28px;
}
.box4 {
  width: 171px;
  height: 171px;
}
.box5 {
  width: 170px;
  height: 170px;
}
.box6 {
  margin-top: 11px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
}
.box7 {
  margin-left: 10px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  opacity: 1;
}
.box8 {
  height: 698px;
  overflow-y: auto;
}
.box9 {
  display: flex;
  font-size: 18px;
  font-family: Medium;
}
.box10 {
  margin-top: 2px;
  width: 4px;
  height: 20px;
  background: #4275f5;
}
.box11 {
  margin-left: 8px;
}
.box12 {
  margin-top: 24px;
  font-family: Medium;
}
.box13 {
  color: #333333;
  font-size: 15px;
}
.box14 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  margin: 10px 10px 0 0;
}
.box15 {
  margin-top: 24px;
  font-family: Medium;
}
.box16 {
  margin-left: 5px;
}

.box17 {
  margin: 10px auto auto auto;
}
.box18 {
  height: 700px;
  overflow-y: auto;
}
.box19 {
  width: 480px;
}
.box20 {
  height: 220px;
}
.box21 {
  color: #fff;
  background: #507df7;
  border: 0;
  margin-left: 50px;
}
.box22 {
  padding: 5px;
  font-size: 16px;
  color: #272748;
  width: 100%;
  height: auto;
}
.box23 {
  border-radius: 12px;
}
.box24 {
  background: #f1f3f7;
  margin-left: 13px;
}
.box25 {
  margin-left: 12px;
}

.box26 {
  width: 20px;
  height: 20px;
  margin-top: 2px;
}

.box27 {
  margin: 0px 5px;
}
.box28 {
  height: 700px;
  overflow-y: auto;
  width: 494px;
}
.box29 {
  font-size: 16px;
  font-family: Regular;
  margin-bottom: 10px;
}
.box30 {
  height: 540px;
  background: #fff;
  padding: 28px 20px;
  border-radius: 12px;
}
.box31 {
  display: flex;
  font-size: 18px;
  font-family: Medium;
}
.box32 {
  margin-top: 2px;
  width: 4px;
  height: 20px;
  background: #4275f5;
}
.box33 {
  margin-left: 8px;
}
.box34 {
  margin-top: 20px;
}
.box35 {
  width: 16px;
  height: 16px;
}
.box36 {
  margin-top: 10px;
  width: 240px;
  height: 250px;
  background: #ffffff;
  border-radius: 12px;
  padding: 28px 20px;
}
.box37 {
  margin-top: 24px;
  font-family: Medium;
  font-size: 14px;
}
.box38 {
  width: 16px;
  height: 16px;
  margin-top: 4px;
}
.box39 {
  margin-left: 4px;
}

.box47 {
  position: absolute;
  top: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}
.box48 {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
}
.box49 {
  text-align: center;
  font-size: 18px;
  font-family: Bold;
}
.percentage {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  background: #507cf7;
  border-radius: 10px;
  z-index: 1;
}
.digSHowBox {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
  .cameraBox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: 380px;
    background: #ffffff;
    border-radius: 12px;
    padding: 25px 25px;
    font-family: Medium;
    font-size: 16px;
    .bkBox {
      width: 172px;
      height: 172px;
      margin: 0 auto;
      position: relative;
      .bk {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .camerBtn {
      width: 180px;
      height: 50px;
      background: #4275f5;
      opacity: 1;
      border-radius: 25px;
      font-family: Medium;
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      margin: 28px auto auto auto;
    }
  }
}
.camera_outer {
  position: relative;
  overflow: hidden;
  // background: url("../../assets/img/user_0608_04.png") no-repeat center;
  background-size: 100%;

  video,
  canvas,
  .tx_img {
    -moz-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  .btn_camera {
    position: absolute;
    bottom: 4px;
    left: 0;
    right: 0;
    height: 50px;
    background-color: rgba(0, 0, 0, 0.3);
    line-height: 50px;
    text-align: center;
    color: #ffffff;
  }

  .bg_r_img {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  .img_bg_camera {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;

    img {
      width: 300px;
      height: 300px;
    }

    .img_btn_camera {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.3);
      color: #ffffff;

      .loding_img {
        width: 50px;
        height: 50px;
      }
    }
  }
}
.scollBox {
  overflow-x: hidden;
}
.scollBox::-webkit-scrollbar {
  width: 4px;
}
.scollBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.scollBox::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.header {
  width: 100%;
  height: 60px;
  background: url('../../assets/listImgs/head_bc@2x.png') 100% 100%;
  padding: 0 100px;
  line-height: 60px;
  font-family: Medium;
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 18px;

  .time {
    width: 220px;
    height: 40px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 31px;
    margin-top: 10px;
    font-size: 16px;
    color: #fff;
    line-height: 40px;
    text-align: center;
  }
}

.examBanner {
  margin-top: 15px;
  padding: 0 100px;
  display: flex;
  background: rgb(240, 243, 247);
  .examLeft {
    width: 240px;
    height: 800px;
    background: #ffffff;
    opacity: 1;
    border-radius: 12px;
    padding: 28px 20px;

    .danBox {
      display: flex;
      flex-wrap: wrap;
      font-family: Medium;
      font-size: 14px;
      .color5 {
        background: #5ad068;
        color: #fff;
        cursor: pointer;
      }
      .color6 {
        background: #f1f3f7;
        color: #8793a4;
        cursor: pointer;
      }
      .color7 {
        background: #4275f5;
        color: #fff;
        cursor: pointer;
      }
      div:nth-child(5n) {
        margin-right: 0 !important;
      }
    }
    .optionTips {
      width: 200px;
      height: 50px;
      border: 1px solid #8793a4;
      opacity: 1;
      border-radius: 12px;
      display: flex;
      align-items: center;
      color: #666666;
      font-family: Regular;
      font-size: 14px;
      .yuan {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        opacity: 1;
      }
    }
  }
  .examCenter {
    width: 1220px;
    height: 800px;
    background: #ffffff;
    opacity: 1;
    border-radius: 12px;
    margin-left: 10px;
    padding: 20px;
    .timu {
      position: relative;
      width: 650px;
      max-height: 760px;
      background: #f5f7fb;
      opacity: 1;
      border-radius: 12px;
      overflow-y: auto;
      padding: 54px 25px;
      color: #333333;
      font-family: Medium;
      font-size: 28px;
      .titleTips {
        position: absolute;
        top: 0;
        left: 0;
        width: 72px;
        height: 30px;
        background: #59cc62;
        border-radius: 12px 0px 12px 0px;
        color: #fff;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
      }
    }
    .timu::-webkit-scrollbar {
      width: 4px;
    }
    .timu::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.2);
    }
    .timu::-webkit-scrollbar-track {
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }
    .xuanx {
      margin-left: 35px;
      .xuan {
        width: 480px;
        min-height: 60px;
        background: #f5f7fb;
        opacity: 1;
        border-radius: 12px;
        padding: 20px;
        display: flex;
        font-size: 22px;
        font-family: Regular;
        cursor: pointer;
        margin-bottom: 20px;
      }
      .seletXuan {
        background: rgba(66, 117, 245, 0.15) !important;
        color: #4275f5 !important;
      }
      .switchBox {
        display: flex;
        margin-left: 55px;
        .btn {
          width: 160px;
          height: 50px;
          border: 1px solid #4275f5;
          opacity: 1;
          border-radius: 25px;
          cursor: pointer;
          text-align: center;
          line-height: 50px;
          font-family: Medium;
          font-size: 16px;
        }
      }
    }
  }
  .examRight {
    width: 240px;
    height: 800px;
    opacity: 1;
    border-radius: 12px;
    margin-left: 10px;
    .fs {
      font-family: Regular;
      font-size: 14px;
      color: #666666;
      line-height: 23px;
      height: 350px;
      overflow-y: scroll;
    }
    .qd {
      margin-left: 20px;
      margin-top: 30px;
      width: 160px;
      height: 50px;
      background: #d3d3d3;
      opacity: 1;
      border-radius: 12px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 16px;
      font-family: Medium;
    }
    .submit {
      margin-left: 20px;
      margin-top: 42px;
      width: 160px;
      height: 50px;
      background: #fe5f5e;
      box-shadow: 0px 3px 6px rgba(254, 95, 94, 0.31);
      opacity: 1;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #fff;
      font-size: 16px;
      font-family: Medium;
    }
  }
}
</style>
